// packages/react/direction/src/Direction.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var DirectionContext = React.createContext(void 0);
var DirectionProvider = function DirectionProvider(props) {
  var dir = props.dir,
    children = props.children;
  return /* @__PURE__ */jsx(DirectionContext.Provider, {
    value: dir,
    children: children
  });
};
function useDirection(localDir) {
  var globalDir = React.useContext(DirectionContext);
  return localDir || globalDir || "ltr";
}
var Provider = DirectionProvider;
export { DirectionProvider, Provider, useDirection };